import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { configData } from "../config";

const initialState = {
    status: false,
    error: {},
    savedEntity: {},
    updateEntity: {},
    isConvertedToParty: false,
    isEdit: false,
    products: [],
    auth_token: {},
    tenant_id: '',
    tenant: {},
    createStatus: false,
    loading: false,
    errorStatus: false

}


export const verifyBusinessDecrypt = createAsyncThunk("enquirySlice/verifyBusiness", async (args, { rejectWithValue }) => {
    console.log("args data", args)
    // let formData = args.formData;
    try {
        const response = await axios.post(`${configData.API_URL}tenants/verify-business`, {
            data: args,
        });
        console.log("response", response);

        return response?.data;
    } catch (err) {
        console.error("Error decrypting data:", err);
        return rejectWithValue(err)
    }
});




export const fetchProducts = createAsyncThunk("enquirySlice/fetchProducts", async (args, { rejectWithValue }) => {
    const token = args.token;
    const tenantId = args.tenant_id;
    try {
        const response = await axios.get(`${configData.API_URL}subscriptions/product`, {
            headers: {
                Authorization: `Bearer ${token}`,
                "X-Tenant": tenantId,
            },
        });
        return response?.data?.data;

    }
    catch (error) {
        console.error("Error decrypting data:", error);
        return rejectWithValue(error)
    }
})


export const createEnquiryReq = createAsyncThunk(
    "enquirySlice/create",
    async (args, { rejectWithValue }) => {
        try {
            const token = args.token;
            const data = args.values;
            const tenantId = args.tenant_id;
            console.log("args", args)
            const response = await axios.post(`${configData.API_URL}enquiry`, data, {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                    "X-Tenant": tenantId,
                },
            });

            return response.data;

        } catch (error) {
            return rejectWithValue(error)
        }
    }
)


const enquirySlice = createSlice({
    name: "enquirySlice",
    initialState: initialState,
    reducers: {
        resetCreateEnquiry: () => initialState,
        resetEquiryStatus(state, action) {
            state.status = false;
            state.error = '';
            state.createStatus = false;
            state.errorStatus = false;
        },
    },
    extraReducers(builder) {
        builder
            .addCase(verifyBusinessDecrypt.pending, (state, action) => {
                state.loading = true;
            })
            .addCase(verifyBusinessDecrypt.fulfilled, (state, action) => {
                state.status = true;
                state.tenant = action.payload.tenant;
                state.auth_token = action.payload.decryptedData.auth_token
                state.tenant_id = action.payload.decryptedData.tenant_id
                state.loading = false;
            })
            .addCase(verifyBusinessDecrypt.rejected, (state, action) => {
                state.status = false;
                state.error = "Error while verify enquiry. Please try again later."
                state.loading = false;

            })
            .addCase(fetchProducts.pending, (state, action) => {
                state.loading = true;
            })
            .addCase(fetchProducts.fulfilled, (state, action) => {
                state.status = true;
                state.products = action.payload
                state.loading = false;
            })
            .addCase(fetchProducts.rejected, (state, action) => {
                state.status = false;
                state.error = "Error while fetch products. Please try again later."
                state.loading = false;
            })
            .addCase(createEnquiryReq.pending, (state, action) => {
                state.loading = true;
            })
            .addCase(createEnquiryReq.fulfilled, (state, action) => {
                state.createStatus = true;
                state.loading = false;
            })
            .addCase(createEnquiryReq.rejected, (state, action) => {
                state.createStatus = false;
                state.error = "Error while create enquiry. Please try again later."
                state.loading = false;
                state.errorStatus = true;
            });

    }
});

export default enquirySlice.reducer;

export const { resetEquiryStatus, resetCreateEnquiry } = enquirySlice.actions;